import React from "react"
import { Link } from "gatsby"
import phonesmartcards from "../../../images/licence-open.png"
import "./CollectStickersLoggedIn.scss"

const CollectStickersLoggedIn = () => {
	return (
		<div className="collectstickers-loggedin sticker">			
			<p>The PhoneSmart Licence is awarded to your child once they've completed the course. This Dashboard will update along the way so you can follow their progress and download the Licence to mark their big achievement.</p>
			<div className="">
				<img src={phonesmartcards} className="phonesmartcard" alt="phonesmart card"/>
			</div>
		</div>
	)
}

export default CollectStickersLoggedIn
